import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';

export default function Pricing() {
  const { user } = useAuthContext();
  const navi = useNavigate();

  return (
    <div className="">
      <div className="container text-center bg-white py-5">
        <h1 className="mb-4 blueText">Membotic Club Hosting Price</h1>
        <h2 className="mb-4 blueText">Just £10/month per club</h2>
        <p className="lead mb-5">
          Host your club on Membotic with full access to all features. No hidden costs. Cancel anytime.
        </p>

        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow-sm border-0">
              <div className="card-body">
                <h2 className="card-title mb-2 blueText">£10/month</h2>
                <p className="mb-3">
                  <strong>To host a club on Membotic</strong> – you can manage multiple clubs, and only pay for the ones you activate.
                </p>
                <ul className="list-unstyled mb-4 text-start">
                  <li>✅ First 30 days free</li>
                  <li>✅ No setup fees or hidden charges</li>
                  <li>✅ Cancel anytime</li>
                  <li>✅ All platform features included</li>
                  <li>
                    ✅ Low transaction fees:
                    <ul className="ms-3">
                      <li>0.25% application fee on one-off payments</li>
                      <li>0.95% application fee on subscriptions</li>
                      <li>
                        Stripe’s standard processing fees also apply –{' '}
                        <a className="text-primary"
                          href="https://stripe.com/gb/pricing"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Stripe Pricing
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
                <button
                  onClick={() => navi(`${user ? "/CreateClub" : "/Register"}`)}
                  className="saveChanges-button"
                >
                  Start Now
                </button>
              </div>
            </div>
          </div>
        </div>

        <p className="mt-5 text-muted">
          One user can manage multiple clubs from a single account.
        </p>
        <p className="text-muted">
          Questions? Email us at{' '}
          <a href="mailto:info@membotic.com">info@membotic.com</a>
        </p>
      </div>
    </div>
  );
}
